import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSessionLanguage, useSessionSettings } from '@context/SessionSettingsContext'

import { CheckIcon } from '@ui/icons/Check.icon'
import { GlobeIcon } from '@ui/icons/Globe.icon'

import { dispatchLangSelectEvent } from '@utils/language.utils'

import { LabeledLocales } from '@global/locale/Locale'

import { MenuSection } from '../useMenuSections'

export const useLanguageMenu = (): MenuSection => {
  const { t } = useTranslation()
  const locale = useSessionLanguage()
  const [, setSettings] = useSessionSettings()

  return useMemo(
    () => ({
      id: 'language',
      label: t('Language'),
      icon: GlobeIcon,
      children: LabeledLocales.map((langItem) => ({
        id: `lang-${langItem.value}`,
        label: langItem.label,
        rightIcon: langItem.value === locale ? CheckIcon : undefined,
        isSelected: langItem.value === locale,
        onClick: () => {
          setSettings({ locale: langItem.value })
          dispatchLangSelectEvent()
        },
      })),
      screenChildren: LabeledLocales.map((langItem) => ({
        id: `lang-${langItem.value}`,
        label: langItem.label,
        rightIcon: langItem.value === locale ? CheckIcon : undefined,
        isSelected: langItem.value === locale,
        onClick: () => {
          setSettings({ locale: langItem.value })
          dispatchLangSelectEvent()
        },
      })),
    }),
    [t, locale, setSettings]
  )
}
